import React, { useState } from 'react';
import DateRangeSelector from '../DateRangeSelector';

const GICampaignSelectionHeader = ({
  startDate,
  endDate,
  onDatesChange,
  onShowUnansweredSurveys
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  // Fonction pour afficher un résumé des dates sélectionnées
  const getDateSummary = () => {
    if (startDate && endDate) {
      const start = startDate.toLocaleDateString('fr-FR');
      const end = endDate.toLocaleDateString('fr-FR');
      return `${start} - ${end}`;
    }
    return 'Aucune période sélectionnée';
  };

  return (
    <div className="py-4 mb-6 relative z-20">
      {/* Toggle header pour mobile/tablet - masqué en desktop */}
      <div
        className="flex items-center justify-between cursor-pointer md:hidden relative"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {/* Titre centré - affiché uniquement quand le composant est déplié */}
        {isExpanded && (
          <div className="absolute inset-x-0 text-center">
            <div className="text-sm font-medium text-gray-700 dark:text-gray-300">Période</div>
          </div>
        )}

        {/* Résumé des dates - affiché uniquement quand replié */}
        <div className={`flex-1 ${isExpanded ? 'invisible' : 'visible'} max-w-[calc(100%-2rem)]`}>
          {!isExpanded && (
            <div className="text-xs text-gray-500 dark:text-gray-400 line-clamp-2 text-left">
              {getDateSummary()}
            </div>
          )}
        </div>

        {/* Chevron (à droite) */}
        <div className="ml-3 z-10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`h-5 w-5 text-gray-500 dark:text-gray-400 transition-transform duration-200 ${isExpanded ? 'transform rotate-180' : ''}`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>

      {/* Contenu du filtre - toujours visible en desktop */}
      <div className={`${isExpanded ? 'block' : 'hidden'} md:block md:pt-0 pt-4`}>
        <div className="grid grid-cols-1 md:grid-cols-1 gap-3">
          {/* Sélection de dates avec bouton à droite */}
          <div className="flex gap-3 items-end">
            <div className="flex-1">
              <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 text-left mb-1.5">
                Période de recherche
              </label>
              <DateRangeSelector
                startDate={startDate}
                endDate={endDate}
                onDatesChange={onDatesChange}
                maxDateRange={{ value: 12, unit: 'months' }}
                relative={false}
              />
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default GICampaignSelectionHeader;